import styled from "styled-components";

const Video = styled.video`
	height: 100vh;
	width: 100%;
	opacity: ${({ visible }) => visible ? 1 : 0};
`;

export default Video;